"use client";
import React, { useState } from "react";
import stl from "../productDetails.module.scss";
import classnames from "classnames";
import { FmButton } from "@/ui-component";
import { IChildren } from "@/src/app/interface";
interface IProps extends IChildren {
    isShowMore: boolean;
}
const ShowMoreButtonClient: React.FC<IProps> = (props) => {
    const [showMoreDetail, setShowMoreDetail] = useState(false);
    const toggerMoreDetail = () => {
        setShowMoreDetail((prev) => !prev);
    };
    return (
        <>
            <p
                className={classnames({
                    [stl["descrip-hide"]]: !showMoreDetail,
                })}
            >
                {props.children[0]}
            </p>
            {props.isShowMore && !showMoreDetail && (
                <FmButton
                    variant="text"
                    className={classnames(stl["togger-btn"])}
                    onClick={toggerMoreDetail}
                >
                    {props.children[1]}
                </FmButton>
            )}
        </>
    );
};

export default ShowMoreButtonClient;
